var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "main-content",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.title,
        width: "1320px",
        top: "2vh",
        "close-on-click-modal": false,
        "destroy-on-close": true
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "scrollable-div", staticStyle: { width: "100%" } },
        [
          _c("div", { staticStyle: { width: "100%", "padding-top": "5px" } }, [
            _c(
              "div",
              { staticClass: "section" },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { "label-position": "right", "label-width": "60px" }
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-form-item", [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.MasterBillNo")))]
                          ),
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "120px" },
                                attrs: { no: "mbl", disabled: true },
                                model: {
                                  value: _vm.mblData.mbl,
                                  callback: function($$v) {
                                    _vm.$set(_vm.mblData, "mbl", $$v)
                                  },
                                  expression: "mblData.mbl"
                                }
                              }),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "el-button el-button--primary el-button--mini",
                                  staticStyle: {
                                    "min-width": "30px!important",
                                    "margin-left": "2px"
                                  },
                                  on: { click: _vm.selectMBLNoHandler }
                                },
                                [_vm._v("...")]
                              )
                            ],
                            1
                          )
                        ]),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              {
                                staticClass: "blue",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_PurchaseMethod")
                                  )
                                )
                              ]
                            ),
                            _c("cargo-advance-select", {
                              ref: "purchaseMethod",
                              staticStyle: { width: "150px" },
                              attrs: {
                                "tag-value": "code",
                                "static-options":
                                  _vm.SystemConstants.PURCHASE_METHODS,
                                "default-value": _vm.mblData.purchaseMethod,
                                disabled: Boolean(_vm.mblData.mbl)
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.mblData.purchaseMethod = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              {
                                staticClass: "blue",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_PurchaseSource")
                                  )
                                )
                              ]
                            ),
                            _c("cargo-advance-select", {
                              staticStyle: { width: "150px" },
                              attrs: {
                                no: "purchaseSource",
                                filterable: "",
                                "select-type":
                                  _vm.TYPE_NAMES.basic_data_Company,
                                "method-params": { active: true },
                                "default-value":
                                  _vm.mblData.purchaseSource || "",
                                headers: [
                                  _vm.$t("Tool.ShortName"),
                                  _vm.$t("Partners.chineseName")
                                ],
                                fields: ["shortName", "chineseName"],
                                placeholder: " ",
                                disabled: Boolean(_vm.mblData.mbl)
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.mblData.purchaseSource = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              {
                                staticClass: "blue",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_ServiceProduct")
                                  )
                                )
                              ]
                            ),
                            _c("cargo-advance-select", {
                              ref: "serviceProduct",
                              staticStyle: { width: "150px" },
                              attrs: {
                                "select-type":
                                  _vm.TYPE_NAMES.basic_data_AirServiceProduct,
                                "callback-method-type": "value",
                                "default-value": _vm.mblData.serviceProduct,
                                "callback-params": { key: "serviceProduct" }
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.mblData.serviceProduct = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_AirlineProductCode")
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              staticStyle: { width: "150px" },
                              attrs: {
                                no: "airlineProductUuid",
                                clearable: false,
                                filterable: "",
                                "static-options": _vm.airlineProductDownList,
                                "tag-value": "uuid",
                                "tag-name": "name",
                                "filter-tag-names": ["name"],
                                "static-component": new _vm.AutoComplete(),
                                "callback-method-type": "value",
                                "default-value": _vm.mblData.airlineProductUuid,
                                "callback-params": { key: "airlineProductUuid" }
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.mblData.airlineProductUuid = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_RouteMarking")
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "150px" },
                              attrs: { no: "routeMarking" },
                              model: {
                                value: _vm.mblData.routeMarking,
                                callback: function($$v) {
                                  _vm.$set(_vm.mblData, "routeMarking", $$v)
                                },
                                expression: "mblData.routeMarking"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              {
                                staticClass: "blue",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_FlightNumber"))
                                )
                              ]
                            ),
                            _c("el-input", {
                              staticStyle: { width: "120px" },
                              attrs: { no: "voyageFlight" },
                              model: {
                                value: _vm.mblData.voyageFlight,
                                callback: function($$v) {
                                  _vm.$set(_vm.mblData, "voyageFlight", $$v)
                                },
                                expression: "mblData.voyageFlight"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { "label-width": "40px" } },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "blue",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_Airline2"))
                                )
                              ]
                            ),
                            _c("cargo-advance-select", {
                              staticStyle: { width: "150px" },
                              attrs: {
                                no: "41",
                                filterable: "",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Company,
                                "method-params": {
                                  airCmp: true,
                                  companyLob: "airExport",
                                  active: true
                                },
                                "default-value": _vm.mblData.carrierId || "",
                                headers: [
                                  _vm.$t("Tool.ShortName"),
                                  _vm.$t("Partners.chineseName")
                                ],
                                fields: ["shortName", "chineseName"],
                                placeholder: " "
                              },
                              on: {
                                parentCallBack: function(p) {
                                  this$1.mblData.carrierId = p.value || 0
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              {
                                staticClass: "blue",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_FlightDate"))
                                )
                              ]
                            ),
                            _c("el-date-picker", {
                              ref: "etd",
                              staticStyle: { width: "150px" },
                              attrs: {
                                no: "44",
                                type: "datetime",
                                "value-format": "yyyy-MM-dd HH:mm",
                                format: "yyyy-MM-dd HH:mm",
                                clearable: ""
                              },
                              model: {
                                value: _vm.mblData.etd,
                                callback: function($$v) {
                                  _vm.$set(_vm.mblData, "etd", $$v)
                                },
                                expression: "mblData.etd"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              {
                                staticClass: "blue",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_OriginPort"))
                                )
                              ]
                            ),
                            _c("cargo-advance-select", {
                              ref: "portOfDeparture",
                              staticStyle: { width: "110px" },
                              attrs: {
                                no: "6",
                                filterable: "",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Airport,
                                "default-value": _vm.mblData.portOfDeparture,
                                "tag-name": "englishName",
                                placeholder: " "
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.mblData.portOfDeparture = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SeaExport.TransitPort") + "1"
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              ref: "transitPort1",
                              staticStyle: { width: "110px" },
                              attrs: {
                                no: "6",
                                filterable: "",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Airport,
                                "default-value": _vm.mblData.transitPort1,
                                "tag-name": "englishName",
                                placeholder: " "
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.mblData.transitPort1 = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SeaExport.TransitPort") + "2"
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              ref: "transitPort2",
                              staticStyle: { width: "110px" },
                              attrs: {
                                no: "6",
                                filterable: "",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Airport,
                                "default-value": _vm.mblData.transitPort2,
                                "tag-name": "englishName",
                                placeholder: " "
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.mblData.transitPort2 = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SeaExport.PortOfDestination")
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "blue",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.PortOfDestination"))
                                )
                              ]
                            ),
                            _c("cargo-advance-select", {
                              ref: "destinationPortCode",
                              staticStyle: { width: "110px" },
                              attrs: {
                                no: "6",
                                filterable: "",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Airport,
                                "default-value":
                                  _vm.mblData.destinationPortCode,
                                "tag-name": "englishName",
                                placeholder: " "
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.mblData.destinationPortCode = p.value
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_SecondLegFlight")
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "150px" },
                              attrs: { no: "secondFlight" },
                              model: {
                                value: _vm.mblData.secondFlight,
                                callback: function($$v) {
                                  _vm.$set(_vm.mblData, "secondFlight", $$v)
                                },
                                expression: "mblData.secondFlight"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_SecondLegAirline")
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              staticStyle: { width: "150px" },
                              attrs: {
                                no: "secondCarrierId",
                                filterable: "",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Company,
                                "method-params": {
                                  airCmp: true,
                                  companyLob: "airExport",
                                  active: true
                                },
                                "default-value":
                                  _vm.mblData.secondCarrierId || "",
                                headers: [
                                  _vm.$t("Tool.ShortName"),
                                  _vm.$t("Partners.chineseName")
                                ],
                                fields: ["shortName", "chineseName"],
                                placeholder: " "
                              },
                              on: {
                                parentCallBack: function(p) {
                                  this$1.mblData.secondCarrierId = p.value || 0
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "CargoMsg.Cargo_SecondLegDocumentNumber"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "150px" },
                              attrs: { no: "secondMbl" },
                              model: {
                                value: _vm.mblData.secondMbl,
                                callback: function($$v) {
                                  _vm.$set(_vm.mblData, "secondMbl", $$v)
                                },
                                expression: "mblData.secondMbl"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_SecondLegETD")
                            }
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "150px" },
                              attrs: {
                                no: "secondEtd",
                                type: "datetime",
                                clearable: "",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                format: "yyyy-MM-dd HH:mm"
                              },
                              model: {
                                value: _vm.mblData.secondEtd,
                                callback: function($$v) {
                                  _vm.$set(_vm.mblData, "secondEtd", $$v)
                                },
                                expression: "mblData.secondEtd"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_SecondLegETA")
                            }
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "150px" },
                              attrs: {
                                no: "secondEta",
                                type: "datetime",
                                clearable: "",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                format: "yyyy-MM-dd HH:mm"
                              },
                              model: {
                                value: _vm.mblData.secondEta,
                                callback: function($$v) {
                                  _vm.$set(_vm.mblData, "secondEta", $$v)
                                },
                                expression: "mblData.secondEta"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              {
                                staticClass: "blue",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.OperationDepartment")
                                  )
                                )
                              ]
                            ),
                            _c("cargo-department-select", {
                              attrs: {
                                no: "77",
                                enables: true,
                                "office-id": Number(
                                  _vm.$store.getters.currentOfficeId
                                ),
                                "department-id": Number(
                                  _vm.mblData.opDepartment
                                ),
                                placeholder: " "
                              },
                              on: {
                                change: function(p) {
                                  _vm.mblData.opDepartment = p.value
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_ThirdLegFlight")
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "150px" },
                              attrs: { no: "thirdFlight" },
                              model: {
                                value: _vm.mblData.thirdFlight,
                                callback: function($$v) {
                                  _vm.$set(_vm.mblData, "thirdFlight", $$v)
                                },
                                expression: "mblData.thirdFlight"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_ThirdLegAirline")
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              staticStyle: { width: "150px" },
                              attrs: {
                                no: "thirdCarrierId",
                                filterable: "",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Company,
                                "method-params": {
                                  airCmp: true,
                                  companyLob: "airExport",
                                  active: true
                                },
                                "default-value":
                                  _vm.mblData.thirdCarrierId || "",
                                headers: [
                                  _vm.$t("Tool.ShortName"),
                                  _vm.$t("Partners.chineseName")
                                ],
                                fields: ["shortName", "chineseName"],
                                placeholder: " "
                              },
                              on: {
                                parentCallBack: function(p) {
                                  this$1.mblData.thirdCarrierId = p.value || 0
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "CargoMsg.Cargo_ThirdLegDocumentNumber"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "150px" },
                              attrs: { no: "thirdMbl" },
                              model: {
                                value: _vm.mblData.thirdMbl,
                                callback: function($$v) {
                                  _vm.$set(_vm.mblData, "thirdMbl", $$v)
                                },
                                expression: "mblData.thirdMbl"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_ThirdLegETD")
                            }
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "150px" },
                              attrs: {
                                no: "thirdEtd",
                                type: "datetime",
                                clearable: "",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                format: "yyyy-MM-dd HH:mm"
                              },
                              model: {
                                value: _vm.mblData.thirdEtd,
                                callback: function($$v) {
                                  _vm.$set(_vm.mblData, "thirdEtd", $$v)
                                },
                                expression: "mblData.thirdEtd"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_ThirdLegETA")
                            }
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "150px" },
                              attrs: {
                                no: "thirdEta",
                                type: "datetime",
                                clearable: "",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                format: "yyyy-MM-dd HH:mm"
                              },
                              model: {
                                value: _vm.mblData.thirdEta,
                                callback: function($$v) {
                                  _vm.$set(_vm.mblData, "thirdEta", $$v)
                                },
                                expression: "mblData.thirdEta"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          ]),
          _c("div", { staticStyle: { "flex-direction": "column" } }, [
            _c(
              "div",
              { staticClass: "section" },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { "label-position": "right", "label-width": "62px" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "goods-info" },
                      [
                        _c("el-form-item", { staticClass: "auto-width" }, [
                          _c(
                            "div",
                            {
                              staticClass: "title-row",
                              staticStyle: {
                                display: "flex",
                                "text-align": "left"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "font-weight": "normal",
                                    color: "#404144",
                                    "white-space": "nowrap",
                                    width: "180px",
                                    "text-align": "center"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Quantity")))]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "font-weight": "normal",
                                    color: "#404144",
                                    "white-space": "nowrap",
                                    width: "180px",
                                    "text-align": "center"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.Weight")) + "KGS"
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "font-weight": "normal",
                                    color: "#404144",
                                    "white-space": "nowrap",
                                    width: "180px",
                                    "text-align": "center"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.Cubage")) + "CBM"
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "font-weight": "normal",
                                    color: "#404144",
                                    "white-space": "nowrap",
                                    width: "180px",
                                    "text-align": "center"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.ChargedWeight") + "KGS"
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "font-weight": "normal",
                                    color: "#404144",
                                    "white-space": "nowrap",
                                    width: "180px",
                                    "text-align": "center"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("queryJob.Density")) + "kg/m³"
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "font-weight": "normal",
                                    color: "#404144",
                                    "white-space": "nowrap",
                                    width: "230px",
                                    "text-align": "center"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_Size")) + "CM"
                                  )
                                ]
                              )
                            ]
                          )
                        ]),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("SeaExport.Booking") } },
                          [
                            _c("auto-number-input", {
                              staticStyle: { width: "180px" },
                              attrs: { no: "94", precision: 0, min: 0 },
                              model: {
                                value: _vm.mblData.quantityBooking,
                                callback: function($$v) {
                                  _vm.$set(_vm.mblData, "quantityBooking", $$v)
                                },
                                expression: "mblData.quantityBooking"
                              }
                            }),
                            _c("auto-number-input", {
                              staticStyle: { width: "180px" },
                              attrs: { no: "95", precision: 3, min: 0 },
                              on: { change: _vm.weightCubAgeChangeHandler },
                              model: {
                                value: _vm.mblData.weightBooking,
                                callback: function($$v) {
                                  _vm.$set(_vm.mblData, "weightBooking", $$v)
                                },
                                expression: "mblData.weightBooking"
                              }
                            }),
                            _c("auto-number-input", {
                              staticStyle: { width: "180px" },
                              attrs: { no: "96", precision: 3, min: 0 },
                              on: { change: _vm.weightCubAgeChangeHandler },
                              model: {
                                value: _vm.mblData.cubageBooking,
                                callback: function($$v) {
                                  _vm.$set(_vm.mblData, "cubageBooking", $$v)
                                },
                                expression: "mblData.cubageBooking"
                              }
                            }),
                            _c("auto-number-input", {
                              staticStyle: { width: "180px" },
                              attrs: { no: "97", precision: 3, min: 0 },
                              model: {
                                value: _vm.mblData.chargeWeightBooking,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.mblData,
                                    "chargeWeightBooking",
                                    $$v
                                  )
                                },
                                expression: "mblData.chargeWeightBooking"
                              }
                            }),
                            _c("auto-number-input", {
                              staticStyle: { width: "180px" },
                              attrs: { precision: 3, min: 0, no: "141" },
                              model: {
                                value: _vm.mblData.densityBooking,
                                callback: function($$v) {
                                  _vm.$set(_vm.mblData, "densityBooking", $$v)
                                },
                                expression: "mblData.densityBooking"
                              }
                            }),
                            _c("el-input", {
                              staticStyle: {
                                width: "230px",
                                "padding-right": "5px"
                              },
                              attrs: { no: "9", disabled: true },
                              model: {
                                value: _vm.measurements,
                                callback: function($$v) {
                                  _vm.measurements = $$v
                                },
                                expression: "measurements"
                              }
                            }),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.onView(_vm.measurements)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.View")))]
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "goods-info-item",
                            attrs: { label: _vm.$t("SeaExport.Frontcabin") }
                          },
                          [
                            _c("auto-number-input", {
                              staticStyle: { width: "180px" },
                              attrs: {
                                no: "98",
                                precision: 0,
                                min: 0,
                                disabled: true
                              },
                              model: {
                                value: _vm.mblData.quantityActual,
                                callback: function($$v) {
                                  _vm.$set(_vm.mblData, "quantityActual", $$v)
                                },
                                expression: "mblData.quantityActual"
                              }
                            }),
                            _c("auto-number-input", {
                              staticStyle: { width: "180px" },
                              attrs: {
                                no: "99",
                                precision: 3,
                                min: 0,
                                disabled: true
                              },
                              on: { change: _vm.weightActualChange },
                              model: {
                                value: _vm.mblData.weightActual,
                                callback: function($$v) {
                                  _vm.$set(_vm.mblData, "weightActual", $$v)
                                },
                                expression: "mblData.weightActual"
                              }
                            }),
                            _c("auto-number-input", {
                              staticStyle: { width: "180px" },
                              attrs: {
                                no: "100",
                                precision: 3,
                                min: 0,
                                disabled: true
                              },
                              on: { change: _vm.weightActualChange },
                              model: {
                                value: _vm.mblData.cubageActual,
                                callback: function($$v) {
                                  _vm.$set(_vm.mblData, "cubageActual", $$v)
                                },
                                expression: "mblData.cubageActual"
                              }
                            }),
                            _c("auto-number-input", {
                              staticStyle: { width: "180px" },
                              attrs: {
                                no: "101",
                                precision: 3,
                                min: 0,
                                disabled: true
                              },
                              on: {
                                change: function($event) {
                                  return _vm.pm.weightCubageChangeHandler(
                                    "chargeWeightActual"
                                  )
                                }
                              },
                              model: {
                                value: _vm.mblData.cWeight,
                                callback: function($$v) {
                                  _vm.$set(_vm.mblData, "cWeight", $$v)
                                },
                                expression: "mblData.cWeight"
                              }
                            }),
                            _c("auto-number-input", {
                              staticStyle: { width: "180px" },
                              attrs: {
                                precision: 3,
                                min: 0,
                                disabled: true,
                                no: "142"
                              },
                              model: {
                                value: _vm.mblData.densityActual,
                                callback: function($$v) {
                                  _vm.$set(_vm.mblData, "densityActual", $$v)
                                },
                                expression: "mblData.densityActual"
                              }
                            }),
                            _c("el-input", {
                              staticStyle: {
                                width: "230px",
                                "padding-right": "5px"
                              },
                              attrs: { no: "9", disabled: true },
                              model: {
                                value: _vm.mblData.dimensionsActual,
                                callback: function($$v) {
                                  _vm.$set(_vm.mblData, "dimensionsActual", $$v)
                                },
                                expression: "mblData.dimensionsActual"
                              }
                            }),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.onView(
                                      _vm.mblData.dimensionsActual
                                    )
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.View")))]
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "goods-info-item",
                            attrs: { label: _vm.$t("SeaExport.FreightStation") }
                          },
                          [
                            _c("auto-number-input", {
                              staticStyle: { width: "180px" },
                              attrs: {
                                no: "150",
                                precision: 0,
                                min: 0,
                                disabled: true
                              },
                              model: {
                                value: _vm.mblData.quantityStation,
                                callback: function($$v) {
                                  _vm.$set(_vm.mblData, "quantityStation", $$v)
                                },
                                expression: "mblData.quantityStation"
                              }
                            }),
                            _c("auto-number-input", {
                              staticStyle: { width: "180px" },
                              attrs: {
                                no: "151",
                                precision: 3,
                                min: 0,
                                disabled: true
                              },
                              on: { change: _vm.weightStationChange },
                              model: {
                                value: _vm.mblData.weightStation,
                                callback: function($$v) {
                                  _vm.$set(_vm.mblData, "weightStation", $$v)
                                },
                                expression: "mblData.weightStation"
                              }
                            }),
                            _c("auto-number-input", {
                              staticStyle: { width: "180px" },
                              attrs: {
                                no: "152",
                                precision: 3,
                                min: 0,
                                disabled: true
                              },
                              on: { change: _vm.weightStationChange },
                              model: {
                                value: _vm.mblData.cubageStation,
                                callback: function($$v) {
                                  _vm.$set(_vm.mblData, "cubageStation", $$v)
                                },
                                expression: "mblData.cubageStation"
                              }
                            }),
                            _c("auto-number-input", {
                              staticStyle: { width: "180px" },
                              attrs: {
                                no: "153",
                                precision: 3,
                                min: 0,
                                disabled: true
                              },
                              model: {
                                value: _vm.mblData.chargeWeightStation,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.mblData,
                                    "chargeWeightStation",
                                    $$v
                                  )
                                },
                                expression: "mblData.chargeWeightStation"
                              }
                            }),
                            _c("auto-number-input", {
                              staticStyle: { width: "180px" },
                              attrs: {
                                precision: 3,
                                min: 0,
                                no: "154",
                                disabled: true
                              },
                              model: {
                                value: _vm.mblData.densityStation,
                                callback: function($$v) {
                                  _vm.$set(_vm.mblData, "densityStation", $$v)
                                },
                                expression: "mblData.densityStation"
                              }
                            }),
                            _c("el-input", {
                              staticStyle: {
                                width: "230px",
                                "padding-right": "5px"
                              },
                              attrs: { disabled: true, no: "9" },
                              model: {
                                value: _vm.mblData.dimensionsStation,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.mblData,
                                    "dimensionsStation",
                                    $$v
                                  )
                                },
                                expression: "mblData.dimensionsStation"
                              }
                            }),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.onView(
                                      _vm.mblData.dimensionsStation
                                    )
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.View")))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          ]),
          _c("div", { staticStyle: { width: "100%", "padding-top": "5px" } }, [
            _c(
              "div",
              { staticClass: "section" },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { "label-position": "right", "label-width": "62px" }
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_FreightUnitPrice")
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("auto-number-input", {
                                  staticStyle: { width: "200px" },
                                  attrs: {
                                    no: "freightAmount",
                                    precision: 2,
                                    "enforce-min": true,
                                    min: 0
                                  },
                                  model: {
                                    value: _vm.mblData.freightAmount,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.mblData,
                                        "freightAmount",
                                        $$v
                                      )
                                    },
                                    expression: "mblData.freightAmount"
                                  }
                                }),
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "80px" },
                                    attrs: { no: "freightType" },
                                    model: {
                                      value: _vm.mblData.freightType,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.mblData,
                                          "freightType",
                                          $$v
                                        )
                                      },
                                      expression: "mblData.freightType"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_UnitPrice"
                                        ),
                                        value: 0
                                      }
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_TotalPrice"
                                        ),
                                        value: 1
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c("cargo-advance-select", {
                                  staticStyle: { width: "80px" },
                                  attrs: {
                                    filterable: "",
                                    clearable: false,
                                    "select-type":
                                      _vm.selectTypeNames.basic_data_Currency,
                                    "default-value": _vm.mblData.freightCurrency
                                  },
                                  on: {
                                    parentCallBack: function(item) {
                                      return (_vm.mblData.freightCurrency =
                                        item.value)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_SignatureWeight")
                            }
                          },
                          [
                            _c("auto-number-input", {
                              staticStyle: { width: "150px" },
                              attrs: {
                                no: "90",
                                precision: 2,
                                "enforce-min": true,
                                min: 0
                              },
                              model: {
                                value: _vm.mblData.signatureWeight,
                                callback: function($$v) {
                                  _vm.$set(_vm.mblData, "signatureWeight", $$v)
                                },
                                expression: "mblData.signatureWeight"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "CargoMsg.Cargo_SignatureDimensions"
                              )
                            }
                          },
                          [
                            _c("auto-number-input", {
                              staticStyle: { width: "550px" },
                              attrs: {
                                no: "signatureDimensions",
                                precision: 0,
                                min: 0
                              },
                              model: {
                                value: _vm.mblData.signatureDimensions,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.mblData,
                                    "signatureDimensions",
                                    $$v
                                  )
                                },
                                expression: "mblData.signatureDimensions"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_SignatureRemarks")
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "572px" },
                              attrs: {
                                no: "signatureRemark",
                                type: "textarea",
                                rows: 5,
                                maxlength: "200",
                                "show-word-limit": ""
                              },
                              model: {
                                value: _vm.mblData.signatureRemark,
                                callback: function($$v) {
                                  _vm.$set(_vm.mblData, "signatureRemark", $$v)
                                },
                                expression: "mblData.signatureRemark"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "CargoMsg.Cargo_FoldedWeightRemarks"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "550px" },
                              attrs: {
                                no: "foldedWeightRemark",
                                type: "textarea",
                                rows: 5,
                                maxlength: "200",
                                "show-word-limit": ""
                              },
                              model: {
                                value: _vm.mblData.foldedWeightRemark,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.mblData,
                                    "foldedWeightRemark",
                                    $$v
                                  )
                                },
                                expression: "mblData.foldedWeightRemark"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          ]),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "align-items": "center",
                width: "100%"
              }
            },
            [
              _c(
                "div",
                { staticStyle: { "padding-left": "10px", width: "10%" } },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("CargoMsg.Cargo_OrderQuantity")) +
                        ": " +
                        _vm._s(_vm.lclData.length)
                    )
                  ])
                ]
              ),
              _c(
                "div",
                { staticStyle: { width: "90%", "text-align": "center" } },
                [
                  _c(
                    "div",
                    { staticStyle: { "padding-right": "10%" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.routeBookingStagingHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("queryJob.temporaryStorage")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.okHandler(false)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ConfirmR")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.okAndBookingHandler }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "CargoMsg.Cargo_ConfirmAndBookingCompleted"
                              )
                            )
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              )
            ]
          ),
          _c("hr"),
          _vm._l(_vm.lclData, function(item, index) {
            return _c(
              "div",
              { key: index, staticClass: "container" },
              [
                _c("div", { staticClass: "order-info" }, [
                  _c("h2", { staticStyle: { "font-size": "20px" } }, [
                    _vm._v(_vm._s(String(index + 1).padStart(2, "0")))
                  ]),
                  _c("h2", [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_OrderNumber")) + "：")
                  ]),
                  _c(
                    "a",
                    {
                      staticStyle: { color: "#0A0AFF" },
                      attrs: { href: "javascript:void(0)" },
                      on: {
                        click: function($event) {
                          return _vm.jumpBusinessHandler(item.jobNo)
                        }
                      }
                    },
                    [_vm._v(_vm._s(item.jobNo))]
                  ),
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.$t("CargoMsg.Cargo_SeparateNumber")) + "："
                    )
                  ]),
                  _vm._v(" " + _vm._s(item.hbl) + " ")
                ]),
                _c(
                  "el-form",
                  {
                    staticStyle: { width: "100%", "padding-left": "20px" },
                    attrs: { "label-position": "right", "label-width": "62px" }
                  },
                  [
                    _c("div", { staticClass: "goods-info" }, [
                      _c(
                        "div",
                        { staticClass: "section" },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_Customer")
                                  }
                                },
                                [
                                  _c("cargo-company-select", {
                                    staticStyle: { width: "500px" },
                                    attrs: {
                                      "method-params": { customer: true },
                                      "default-value": item.customerId,
                                      no: "customerId",
                                      disabled: true
                                    },
                                    on: {
                                      change: function(p) {
                                        item.customerId = p.value
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.SpaceRquirement")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "300px" },
                                    attrs: { no: "9", disabled: true },
                                    model: {
                                      value: item.cabinReq,
                                      callback: function($$v) {
                                        _vm.$set(item, "cabinReq", $$v)
                                      },
                                      expression: "item.cabinReq"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SeaExport.OnBoardRequirements"
                                    )
                                  }
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "360px" },
                                    attrs: { no: "9", disabled: true },
                                    model: {
                                      value: item.loadReq,
                                      callback: function($$v) {
                                        _vm.$set(item, "loadReq", $$v)
                                      },
                                      expression: "item.loadReq"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_TransshipmentPort"
                                    )
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    ref: "transshipmentPort",
                                    refInFor: true,
                                    staticStyle: { width: "163px" },
                                    attrs: {
                                      no: "transshipmentPort",
                                      filterable: "",
                                      "select-type":
                                        _vm.TYPE_NAMES.basic_data_Airport,
                                      "default-value": item.transshipmentPort,
                                      "tag-name": "englishName",
                                      placeholder: " "
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        item.transshipmentPort = p.value
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_TransshipmentFee"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c("auto-number-input", {
                                        staticStyle: { width: "100px" },
                                        attrs: {
                                          no: "90",
                                          precision: 2,
                                          "enforce-min": true,
                                          min: 0
                                        },
                                        model: {
                                          value: item.transshipAmount,
                                          callback: function($$v) {
                                            _vm.$set(
                                              item,
                                              "transshipAmount",
                                              $$v
                                            )
                                          },
                                          expression: "item.transshipAmount"
                                        }
                                      }),
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100px" },
                                          model: {
                                            value: item.transshipType,
                                            callback: function($$v) {
                                              _vm.$set(
                                                item,
                                                "transshipType",
                                                $$v
                                              )
                                            },
                                            expression: "item.transshipType"
                                          }
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_UnitPrice"
                                              ),
                                              value: 0
                                            }
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_TotalPrice"
                                              ),
                                              value: 1
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c("cargo-advance-select", {
                                        staticStyle: { width: "100px" },
                                        attrs: {
                                          filterable: "",
                                          clearable: false,
                                          "select-type":
                                            _vm.selectTypeNames
                                              .basic_data_Currency,
                                          "default-value":
                                            item.transshipCurrency
                                        },
                                        on: {
                                          parentCallBack: function(i) {
                                            return (item.transshipCurrency =
                                              i.value)
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_market")
                                  }
                                },
                                [
                                  _c("cargo-user-select", {
                                    ref: "sales",
                                    refInFor: true,
                                    staticStyle: { width: "80px", flex: "1" },
                                    attrs: {
                                      no: "72",
                                      disabled: true,
                                      "method-params": {
                                        officeId: _vm.salesOfficeCheck
                                          ? _vm.$store.getters.currentOfficeId
                                          : "",
                                        category: "role",
                                        shape: "sales",
                                        active: true
                                      },
                                      "default-value": item.sales || "",
                                      "static-options": _vm.salesList
                                    },
                                    on: {
                                      change: function(p) {
                                        item.sales = p.value
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_ResponsibleCustomerService"
                                    )
                                  }
                                },
                                [
                                  _c("cargo-user-select", {
                                    ref: "csr",
                                    refInFor: true,
                                    staticStyle: { width: "80px" },
                                    attrs: {
                                      no: "70",
                                      disabled: true,
                                      "method-params": {
                                        category: "role",
                                        shape: "csr"
                                      },
                                      "default-value": item.csr || "",
                                      "merge-load": true
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_ResponsibleOperator"
                                    )
                                  }
                                },
                                [
                                  _c("cargo-user-select", {
                                    ref: "csr",
                                    refInFor: true,
                                    staticStyle: { width: "75px" },
                                    attrs: {
                                      no: "70",
                                      disabled: true,
                                      "method-params": {
                                        category: "role",
                                        shape: "op"
                                      },
                                      "default-value": item.op || "",
                                      "merge-load": true
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c("el-form-item", { staticClass: "auto-width" }, [
                            _c(
                              "div",
                              {
                                staticClass: "title-row",
                                staticStyle: {
                                  display: "flex",
                                  "text-align": "left"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-size": "12px",
                                      "font-weight": "normal",
                                      color: "#404144",
                                      "white-space": "nowrap",
                                      width: "135px",
                                      "text-align": "center"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Quantity")))]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-size": "12px",
                                      "font-weight": "normal",
                                      color: "#404144",
                                      "white-space": "nowrap",
                                      width: "135px",
                                      "text-align": "center"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.Weight")) + "KGS"
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-size": "12px",
                                      "font-weight": "normal",
                                      color: "#404144",
                                      "white-space": "nowrap",
                                      width: "135px",
                                      "text-align": "center"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.Cubage")) + "CBM"
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-size": "12px",
                                      "font-weight": "normal",
                                      color: "#404144",
                                      "white-space": "nowrap",
                                      width: "135px",
                                      "text-align": "center"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.ChargedWeight") +
                                          "KGS"
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-size": "12px",
                                      "font-weight": "normal",
                                      color: "#404144",
                                      "white-space": "nowrap",
                                      width: "135px",
                                      "text-align": "center"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("queryJob.Density")) +
                                        "kg/m³"
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-size": "12px",
                                      "font-weight": "normal",
                                      color: "#404144",
                                      "white-space": "nowrap",
                                      width: "240px",
                                      "text-align": "center"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("CargoMsg.Cargo_Size")) +
                                        "CM"
                                    )
                                  ]
                                )
                              ]
                            )
                          ]),
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.Booking") } },
                            [
                              _c("auto-number-input", {
                                staticStyle: { width: "135px" },
                                attrs: {
                                  no: "94",
                                  precision: 0,
                                  min: 0,
                                  disabled: true
                                },
                                model: {
                                  value: item.quantityBooking,
                                  callback: function($$v) {
                                    _vm.$set(item, "quantityBooking", $$v)
                                  },
                                  expression: "item.quantityBooking"
                                }
                              }),
                              _c("auto-number-input", {
                                staticStyle: { width: "135px" },
                                attrs: {
                                  no: "95",
                                  precision: 3,
                                  min: 0,
                                  disabled: true
                                },
                                model: {
                                  value: item.weightBooking,
                                  callback: function($$v) {
                                    _vm.$set(item, "weightBooking", $$v)
                                  },
                                  expression: "item.weightBooking"
                                }
                              }),
                              _c("auto-number-input", {
                                staticStyle: { width: "135px" },
                                attrs: {
                                  no: "96",
                                  precision: 3,
                                  min: 0,
                                  disabled: true
                                },
                                model: {
                                  value: item.cubageBooking,
                                  callback: function($$v) {
                                    _vm.$set(item, "cubageBooking", $$v)
                                  },
                                  expression: "item.cubageBooking"
                                }
                              }),
                              _c("auto-number-input", {
                                staticStyle: { width: "135px" },
                                attrs: {
                                  no: "97",
                                  precision: 3,
                                  min: 0,
                                  disabled: true
                                },
                                model: {
                                  value: item.chargeWeightBooking,
                                  callback: function($$v) {
                                    _vm.$set(item, "chargeWeightBooking", $$v)
                                  },
                                  expression: "item.chargeWeightBooking"
                                }
                              }),
                              _c("auto-number-input", {
                                staticStyle: { width: "135px" },
                                attrs: {
                                  precision: 3,
                                  min: 0,
                                  no: "141",
                                  disabled: true
                                },
                                model: {
                                  value: item.densityBooking,
                                  callback: function($$v) {
                                    _vm.$set(item, "densityBooking", $$v)
                                  },
                                  expression: "item.densityBooking"
                                }
                              }),
                              _c("el-input", {
                                staticStyle: {
                                  width: "240px",
                                  "padding-right": "5px"
                                },
                                attrs: { no: "9", disabled: true },
                                model: {
                                  value: item.bookingDimensions,
                                  callback: function($$v) {
                                    _vm.$set(item, "bookingDimensions", $$v)
                                  },
                                  expression: "item.bookingDimensions"
                                }
                              }),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", disabled: false },
                                  on: {
                                    click: function($event) {
                                      return _vm.onView(item.bookingDimensions)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.View")))]
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "goods-info-item",
                              attrs: { label: _vm.$t("SeaExport.Frontcabin") }
                            },
                            [
                              _c("auto-number-input", {
                                staticStyle: { width: "135px" },
                                attrs: {
                                  no: "98",
                                  precision: 0,
                                  min: 0,
                                  disabled: true
                                },
                                model: {
                                  value: item.quantityActual,
                                  callback: function($$v) {
                                    _vm.$set(item, "quantityActual", $$v)
                                  },
                                  expression: "item.quantityActual"
                                }
                              }),
                              _c("auto-number-input", {
                                staticStyle: { width: "135px" },
                                attrs: {
                                  no: "99",
                                  precision: 3,
                                  min: 0,
                                  disabled: true
                                },
                                model: {
                                  value: item.weightActual,
                                  callback: function($$v) {
                                    _vm.$set(item, "weightActual", $$v)
                                  },
                                  expression: "item.weightActual"
                                }
                              }),
                              _c("auto-number-input", {
                                staticStyle: { width: "135px" },
                                attrs: {
                                  no: "100",
                                  precision: 3,
                                  min: 0,
                                  disabled: true
                                },
                                model: {
                                  value: item.cubageActual,
                                  callback: function($$v) {
                                    _vm.$set(item, "cubageActual", $$v)
                                  },
                                  expression: "item.cubageActual"
                                }
                              }),
                              _c("auto-number-input", {
                                staticStyle: { width: "135px" },
                                attrs: {
                                  no: "101",
                                  precision: 3,
                                  min: 0,
                                  disabled: true
                                },
                                model: {
                                  value: item.cWeight,
                                  callback: function($$v) {
                                    _vm.$set(item, "cWeight", $$v)
                                  },
                                  expression: "item.cWeight"
                                }
                              }),
                              _c("auto-number-input", {
                                staticStyle: { width: "135px" },
                                attrs: {
                                  precision: 3,
                                  min: 0,
                                  no: "142",
                                  disabled: true
                                },
                                model: {
                                  value: item.densityActual,
                                  callback: function($$v) {
                                    _vm.$set(item, "densityActual", $$v)
                                  },
                                  expression: "item.densityActual"
                                }
                              }),
                              _c("el-input", {
                                staticStyle: {
                                  width: "240px",
                                  "padding-right": "5px"
                                },
                                attrs: { no: "9", disabled: true },
                                model: {
                                  value: item.dimensionsActual,
                                  callback: function($$v) {
                                    _vm.$set(item, "dimensionsActual", $$v)
                                  },
                                  expression: "item.dimensionsActual"
                                }
                              }),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.onView(item.dimensionsActual)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.View")))]
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "goods-info-item",
                              attrs: {
                                label: _vm.$t("SeaExport.FreightStation")
                              }
                            },
                            [
                              _c("auto-number-input", {
                                staticStyle: { width: "135px" },
                                attrs: {
                                  no: "150",
                                  precision: 0,
                                  min: 0,
                                  disabled: true
                                },
                                model: {
                                  value: item.quantityStation,
                                  callback: function($$v) {
                                    _vm.$set(item, "quantityStation", $$v)
                                  },
                                  expression: "item.quantityStation"
                                }
                              }),
                              _c("auto-number-input", {
                                staticStyle: { width: "135px" },
                                attrs: {
                                  no: "151",
                                  precision: 3,
                                  min: 0,
                                  disabled: true
                                },
                                model: {
                                  value: item.weightStation,
                                  callback: function($$v) {
                                    _vm.$set(item, "weightStation", $$v)
                                  },
                                  expression: "item.weightStation"
                                }
                              }),
                              _c("auto-number-input", {
                                staticStyle: { width: "135px" },
                                attrs: {
                                  no: "152",
                                  precision: 3,
                                  min: 0,
                                  disabled: true
                                },
                                model: {
                                  value: item.cubageStation,
                                  callback: function($$v) {
                                    _vm.$set(item, "cubageStation", $$v)
                                  },
                                  expression: "item.cubageStation"
                                }
                              }),
                              _c("auto-number-input", {
                                staticStyle: { width: "135px" },
                                attrs: {
                                  no: "chargeWeightStation",
                                  precision: 3,
                                  min: 0,
                                  disabled: true
                                },
                                model: {
                                  value: item.chargeWeightStation,
                                  callback: function($$v) {
                                    _vm.$set(item, "chargeWeightStation", $$v)
                                  },
                                  expression: "item.chargeWeightStation"
                                }
                              }),
                              _c("auto-number-input", {
                                staticStyle: { width: "135px" },
                                attrs: {
                                  precision: 3,
                                  min: 0,
                                  no: "densityStation",
                                  disabled: true
                                },
                                model: {
                                  value: item.densityStation,
                                  callback: function($$v) {
                                    _vm.$set(item, "densityStation", $$v)
                                  },
                                  expression: "item.densityStation"
                                }
                              }),
                              _c("el-input", {
                                staticStyle: {
                                  width: "240px",
                                  "padding-right": "5px"
                                },
                                attrs: { no: "9", disabled: true },
                                model: {
                                  value: item.dimensionsStation,
                                  callback: function($$v) {
                                    _vm.$set(item, "dimensionsStation", $$v)
                                  },
                                  expression: "item.dimensionsStation"
                                }
                              }),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.onView(item.dimensionsStation)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.View")))]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "SeaExport.EnglishDescriptionOfGoods"
                                )
                              }
                            },
                            [
                              _c("cargo-rich-textarea", {
                                staticStyle: {
                                  height: "110px",
                                  width: "345px"
                                },
                                attrs: {
                                  no: "110",
                                  "text-chars": 0,
                                  "warning-count": 45,
                                  "english-letter-auto-uppercase": true,
                                  disabled: true
                                },
                                model: {
                                  value: item.cargoEnglishName,
                                  callback: function($$v) {
                                    _vm.$set(item, "cargoEnglishName", $$v)
                                  },
                                  expression: "item.cargoEnglishName"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "auto-width",
                              attrs: { label: _vm.$t("SeaExport.Marks") }
                            },
                            [
                              _c("cargo-rich-textarea", {
                                staticStyle: {
                                  height: "110px",
                                  width: "345px"
                                },
                                attrs: {
                                  no: "111",
                                  "text-chars": 0,
                                  "warning-count": 45,
                                  "auto-uppercase": true,
                                  disabled: true
                                },
                                model: {
                                  value: item.mark,
                                  callback: function($$v) {
                                    _vm.$set(item, "mark", $$v)
                                  },
                                  expression: "item.mark"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ]
                )
              ],
              1
            )
          })
        ],
        2
      ),
      _c(
        "div",
        {
          staticStyle: { "text-align": "right" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "default" },
              on: {
                click: function($event) {
                  return _vm.onCancel(false)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Close")))]
          )
        ],
        1
      ),
      _c("select-mawb-dialog", {
        attrs: {
          visible: _vm.selectMawbDialog.visible,
          "carrier-id": _vm.selectMawbDialog.carrierId,
          type: _vm.selectMawbDialog.type,
          "operate-type": _vm.selectMawbDialog.operateType
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.selectMawbDialog, "visible", $event)
          },
          enterEvent: _vm.selectedMAWBHandler
        }
      }),
      _vm.viewWindow.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.viewWindow.visible,
                title: _vm.$t("SeaExport.View"),
                width: "300px",
                "append-to-body": "",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.viewWindow, "visible", $event)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "section", staticStyle: { flex: "1" } },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: true,
                        "label-width": "80px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { "label-width": "0" } },
                        [
                          _c("cargo-rich-textarea", {
                            staticStyle: { height: "110px", width: "280px" },
                            attrs: {
                              no: "viewValue",
                              "text-chars": 0,
                              "warning-count": 1000,
                              disabled: true
                            },
                            model: {
                              value: _vm.viewWindow.viewValue,
                              callback: function($$v) {
                                _vm.$set(_vm.viewWindow, "viewValue", $$v)
                              },
                              expression: "viewWindow.viewValue"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.viewWindow.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }